import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { DragIndicator, Lock } from '@mui/icons-material';

export const DragHandle = (props: any) => {
  const classes = useStyles({ ...props?.isDragging, ...props?.disabledDnD });
  return (
    <span
      className={classes.handleWrapper}
      style={{
        cursor: props?.isDragging ? 'grabbing' : props?.disabledDnD ? 'not-allowed' : 'grab',
      }}
      {...props}
    >
      {props.disabledDnD ? <Lock /> : <DragIndicator />}
    </span>
  );
};

const useStyles = makeStyles<Theme, { isDragging: boolean; disabledDnD: boolean }>(
  (theme: Theme) => ({
    handleWrapper: {
      width: '1rem',
      height: '1rem',
      verticalAlign: 'bottom',
      display: 'inline-block',
      marginRight: '0.5rem',
      '& svg': {
        width: '100%',
        height: '100%',
      },
    },
  })
);
